module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0115-small-f418b417250081638bfd7453f97058ca.png";